export default __webpack_public_path__ + "static/media/O-047.5920f0f6.png";